module.exports = __webpack_public_path__ + "img/weipayimg.85c73ee7.jpg";